import { render } from "./App.vue?vue&type=template&id=39ee60c5"
const script = {}

import "./App.vue?vue&type=style&index=0&id=39ee60c5&lang=scss"
script.render = render

export default script